import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import { isSetToken } from '../vue-apollo'

import DefaultLayout from '../components/layouts/Default'
import AuthLayout from '../components/layouts/Auth'

Vue.use(VueRouter)
Vue.component('default-layout', DefaultLayout)
Vue.component('auth-layout', AuthLayout)

const routes = [
  {
    path: '/stats',
    name: 'stats',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/Stats/Partners'),
    children: [
      {
        path: 'list',
        name: 'stats__partners',
        component: () => import('../views/Stats/Partners'),
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/goods',
    name: 'goods',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/Goods/Gateway'),
    children: [
      {
        path: 'list',
        name: 'goods__gateway',
        component: () => import('../views/Goods/Gateway'),
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/banners',
    name: 'banners',
    component: () => import(/* webpackChunkName: "promo" */ '../views/Banners'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        name: 'banners__list',
        component: () => import(/* webpackChunkName: "promo__list" */ '../views/Banners/List'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'add',
        name: 'banners__add',
        component: () => import(/* webpackChunkName: "promo__add" */ '../views/Banners/Add'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':id',
        name: 'banners__id',
        component: () => import(/* webpackChunkName: "promo__id" */ '../views/Banners/_ID'),
        meta: {
          requiresAuth: true
        }
      }

    ]
  },
  {
    path: '/achievements',
    name: 'achievements',
    component: () => import(/* webpackChunkName: "promo" */ '../views/Achievements'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        name: 'achievements__list',
        component: () => import(/* webpackChunkName: "promo__list" */ '../views/Achievements/List'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'add',
        name: 'achievements__add',
        component: () => import(/* webpackChunkName: "promo__add" */ '../views/Achievements/Add'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':id',
        name: 'achievements__id',
        component: () => import(/* webpackChunkName: "promo__id" */ '../views/Achievements/_ID'),
        meta: {
          requiresAuth: true
        }
      }

    ]
  },
  {
    path: '/clubs',
    name: 'clubs',
    component: () => import('../views/Clubs'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        name: 'clubs__list',
        component: () => import('../views/Clubs/List'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'add',
        name: 'clubs__add',
        component: () => import('../views/Clubs/Add'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':id',
        name: 'clubs__id',
        component: () => import('../views/Clubs/_ID'),
        meta: {
          requiresAuth: true
        }
      }

    ]
  },
  {
    path: '/events',
    name: 'events',
    component: () => import(/* webpackChunkName: "events" */ '../views/Events'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        name: 'events__list',
        component: () => import(/* webpackChunkName: "events__list" */ '../views/Events/List'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'add',
        name: 'events__add',
        component: () => import(/* webpackChunkName: "events__add" */ '../views/Events/Add'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':id',
        name: 'events__id',
        component: () => import(/* webpackChunkName: "events__id" */ '../views/Events/_ID'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import(/* webpackChunkName: "categories" */ '../views/Categories.vue'),
    children: [
      {
        path: '',
        name: 'categories__list',
        component: () => import(/* webpackChunkName: "categories__list" */ '../views/Categories/List')
      },
      {
        path: 'add',
        name: 'categories__add',
        component: () => import(/* webpackChunkName: "categories__add" */ '../views/Categories/Add')
      },
      {
        path: ':id',
        name: 'categories__id',
        component: () => import(/* webpackChunkName: "categories__id" */ '../views/Categories/_ID')
      }

    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true,
      layout: 'auth'
    }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        name: 'users__list',
        component: () => import(/* webpackChunkName: "users__list" */ '../views/Users/List'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':id',
        name: 'users__id',
        component: () => import(/* webpackChunkName: "users__id" */ '../views/Users/_ID'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isSetToken()) {
      next({
        name: 'login'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    next()
  }
})

export default router
